import { render } from "./WaysToHelp.vue?vue&type=template&id=a462f4c8"
import script from "./WaysToHelp.vue?vue&type=script&lang=js"
export * from "./WaysToHelp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__